export default "/assets/plus-purple.svg";